module.exports = __webpack_public_path__ + "img/Group 994one.813cbbd4.png";